export function ready(state) {
  state.readyResolve();
}

export function routerReady(state) {
  state.routerReadyResolve();
}

export function setAccountSettingsDialogState(state, value) {
  state.accountSettingsDialogOpen = value;
}

export function setApiWorker(state, worker) {
  state.apiWorker = worker;
}

export function setBroker(state, broker) {
  state.broker = broker;
}

export function setDeviceInfo(state, deviceInfo) {
  state.deviceInfo = deviceInfo;
}

export function setFilterableRoute(state, isFilterRoute) {
  state.isFilterRoute = isFilterRoute;
}

export function setLiveMapRoute(state, isLiveMapRoute) {
  state.isLiveMapRoute = isLiveMapRoute;
}

export function setLiveUpdateInfo(state, liveUpdateInfo) {
  state.liveUpdateInfo = liveUpdateInfo;
}

export function setMainNavOpen(state, isOpen) {
  state.mainNavOpen = isOpen;
}

export function setNotchSizes(state, sizes) {
  state.notchSizes = { ...state.notchSizes, ...sizes };
}

export function setOrientation(state, orientation) {
  state.orientation = orientation;
}

export function workersReady(state) {
  state.workersReadyResolve();
}
